/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {IngestSearchEntitiesRequest} from '@cash-web/protos/squareup/cash/customersearch/api/IngestSearchEntities.pb'
import {IngestSearchEntitiesResponse} from '@cash-web/protos/squareup/cash/customersearch/api/IngestSearchEntities.pb'


export const ingestSearchEntities = (request:IngestSearchEntitiesRequest, options?: CashRequestOptions) => post<IngestSearchEntitiesRequest, IngestSearchEntitiesResponse>("/2.0/cash/ingest-search-entities", request, {...options, rejectOnError: true })